import { PagePartHolder } from '../../PagePartHolder';

export const BannerHolder = (props) => {
  return <PagePartHolder {...props} outlet="banner" />;
};
